import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDocument, useDocumentOnce } from 'react-firebase-hooks/firestore';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Card, CardContent, CardMedia, createTheme, CardActionArea, CardActions, TextField, Grid, styled, Paper, Chip, FormControl, InputLabel, Select, InputAdornment, FormGroup, FormControlLabel, FormHelperText, Autocomplete, Slide, Dialog, AppBar, List, Checkbox, Link, Stack, CircularProgress, FormLabel, RadioGroup, Radio } from "@mui/material";

import isEqual from 'lodash.isequal';

import UserService from '../../services/user.service';
import Iconify from '../../components/iconify';
import { personprops, tocs } from '../../constants';

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

EditUser.propTypes = {
    profile: PropTypes.object,
    setProfile: PropTypes.func,
    setEditing: PropTypes.func
  };

export default function EditUser(props) {
    const { profile, setProfile, setEditing } = props
    const savedProfile = useRef()
    const editingTimer = useRef()
    const [inputsError, setInputsError] = useState({});
    const [showToc, setShowToc] = useState(false);
    const [saving, setSaving] = useState(false);
    const [tocsState, setTocsState] = useState(tocs.reduce((p, toc) => ({...p, [toc.name] : false}), {}));


    const handleCloseToc = () => {
      setShowToc(false)
    }
    
    useEffect(() => {
      
      console.log(tocsState);
      
    }, [tocsState]);
    const handleTOCChange = (event) => {

      setTocsState({
        ...tocsState,
        [event.target.name]: event.target.checked,
      })

    }
    useEffect(() => {
      if (!savedProfile.current) savedProfile.current = profile
    }, [profile])

    useEffect(() => {
      
      setInputsError(Object.entries(personprops).reduce((p, [name, prop]) => ({...p, [name] : prop.required && !profile[name]}), {}))
      
    }, [profile]);


    const noChanges = useMemo(() =>
      // console.log('checking differences');
       isEqual(savedProfile.current, profile) || (Object.entries(inputsError).some(([_, v]) => v))

    , [savedProfile, profile, inputsError])


  const handleSubmit = useCallback(async (event) => {
    event.preventDefault();

    if (profile && profile.userId) {

        await UserService.updateUserProfile({user: profile}).then(r => {

            // setLog(JSON.stringify(r))
            console.log('r', r);
            if (r) {
                savedProfile.current = profile
                setEditing(false)
            }
        })




      console.log('profile', profile);

    //   if (profile.id) {

    //     // PUT
    //     console.log('profile before putting', profile);
    //     axios.put(`/api/user`, profile).then(function(response){
    //         console.log(response.data);
    //         // setProfile(p => ({ ...p, ...response.data }))
    //         savedProfile.current = profile
    //         setEditing(false)
    //       });

    //   } else {

    //     //  INSERT

    //     const md5 = require('md5');
    //     console.log('profile before posting', profile);
    //     axios.post('/api/user/save', profile).then(function (response) {
    //       console.log(response.data);
    //       if (response.data && response.data.id) {
    //         setProfile(p => ({ ...p, id: response.data.id }))
    //         savedProfile.current = { ...profile, id: response.data.id }
    //       }
    //       setEditing(false)
    //     });
    //   }

}

}, [profile, setEditing])

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const tocsDialog  = (<Dialog
  fullScreen
  open={showToc}
  onClose={handleCloseToc}
  // TransitionComponent={Transition}
>
  <AppBar sx={{ position: 'relative' }}>
    <Toolbar>
      <IconButton
        edge="start"
        color="inherit"
        onClick={handleCloseToc}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
        เงื่อนไขการใช้งานและข้อตกลงเกี่ยวกับการใช้ข้อมูล
      </Typography>
      <Button color="success" variant='contained' onClick={() => {
        setTocsState(tocs.reduce((p, toc) => ({...p, [toc.name] : true}), {}))
        setTimeout(() => {
          setProfile(p => ({...p, tocAccepted: true}))
          handleCloseToc()
        }, 500);
        
      }}>
        ยอมรับทั้งหมด
      </Button>
    </Toolbar>
  </AppBar>
  <FormGroup>
    {tocs.map(toc => (<FormControlLabel 
        key={toc.name}
        required
        control={<Checkbox          
          style={{ pointerEvents: "auto" }}
          disabled={toc.checked}
          checked={toc.checked || tocsState[toc.name]} onChange={handleTOCChange} name={toc.name} />}
        label={<Stack direction={'column'} spacing={0}>
          <p>{toc.label}{'  '}
          <Link
            onClick={(e) => {
              e.preventDefault();
              window.open(toc.uri)
            }}
          >
            อ่าน
          </Link></p>
        {toc.info ? <Typography variant='caption'color={'#555'} >{toc.info}</Typography> : <></>} 

        </Stack>}
        />))}
  </FormGroup>
</Dialog>)

useEffect(() => {
  
  if (!profile) return
  if (profile && !profile.tocAccepted) {
    if (!showToc) setShowToc(true)
  } else {
    setShowToc(false)
  }
  
}, [profile, showToc])


const textfieldsGrid = useMemo(() => {


  const handleProfileEditing = (event, prop) => {
    if (editingTimer.current) clearTimeout(editingTimer.current)
    editingTimer.current = setTimeout(() => {
      setProfile( p => ({...p, [prop] : event.target.value}))      
    }, 100);
    

  }

    console.log('grid updating');
    return (<Grid container spacing={1}>
      {Object.entries(personprops)
        .filter(([key, _ ]) => personprops[key].preferred || personprops[key].required || profile[key])
        .map(([key, prop]) => {
          switch (prop.type) {
            case 'select':

            if (props.options.length < 5) return (
              <FormControl>
                  <FormLabel></FormLabel>
                    <RadioGroup defaultValue={(profile && profile[key]) || ''} name={`${key}-select-label`}>
                    {prop.options.map(r => (<Radio key={r.order || r} value={r.name || r} label={r.name || r} />
                    ))}                   
                    {/* color="success"  */}                      
                  </RadioGroup>
                </FormControl>)
              return (<Grid key={key} item xs={prop.grid || 12}>
              <FormControl fullWidth >
                <InputLabel id={`${key}-select-label`}>{prop.label}</InputLabel>
                <Select
                  fullWidth
                  error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
                  labelId={`${key}-select-label`}
                  id={`${key}-select`}
                  value={(profile && profile[key]) || ''}
                  label={prop.label}
                  onChange={event => {
                    handleProfileEditing(event, key)
                    
                    

                    }
                  }
                >
                  {prop.options.map(r => (<MenuItem key={r.order || r} value={r.name || r} selected={(r.name || r) === profile[key]}>{r.name || r}</MenuItem>))}
                </Select>
                <FormHelperText>{prop.helperText}</FormHelperText>
              </FormControl>
              </Grid>)

            case 'autocomplete':
              // console.log(profile && profile[key].abbr);
              return (<Grid key={key} item xs={prop.grid || 12}>
                <Autocomplete
                  id="grouped-unit"
                  freeSolo
                  defaultValue={profile && profile[key]}
                  blurOnSelect={"touch"}
                  options={prop.options}
                  groupBy={(option) => option.unittype}
                  getOptionLabel={(option) => option[prop.labelkey] || ''}
                  sx={{ width: 300 }}
                  renderInput={(params) => <TextField error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
                   {...params} label={prop.inputlabel} />}
                  onChange={(_, newValue) => {
                    handleProfileEditing({ target: { value: newValue } }, key)
                  }}
                  onInputChange={(event, newInputValue) => {
                    
                    handleProfileEditing({ target: { value: {
                      abbr: newInputValue,
                      unittype: 'others'
                        }
                      }
                    }, key)
                  }}

                />
                <FormHelperText>{prop.helperText}</FormHelperText>


              </Grid>)

            case 'multiple':
              return (<Grid key={key} item xs={prop.grid || 12}>


                <TextField
                error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
                id={key}
                helperText={prop.helperText}
                label={prop.label} variant="outlined"
            // onChange={event => handleProfileEditing(event, key)}
            onKeyDown={(ev) => {
              // console.log(`Pressed keyCode ${ev.key}`);
              if (ev.key === 'Enter') {
                // Do code here
                ev.preventDefault();
                setProfile(p => ({...p, [key]: p[key] ? [...p[key], ev.target.value] : [ev.target.value]}))
                ev.target.value = ""
              }
            }}
              />

            <Paper
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                listStyle: 'none',
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {profile && profile[key] && (Array.isArray(profile[key]) ? profile[key] : [profile[key]]).map((data) => {
                console.log('profile changed');
                return (
                  <ListItem key={data}>
                    <Chip
                      label={data }
                      onDelete={() => {
                        setProfile(p => {
                            console.log('setting profile');
                          return {...p,
                            [key] : (Array.isArray(p[key]) ?  p[key] : [p[key]]).filter(i => i !== data)
                          }
                        })
                      }}
                    />
                  </ListItem>
                );
              })}
            </Paper>

            </Grid>)

            case 'switch':
              return (<Grid key={key} item xs={prop.grid || 12}>

              <FormGroup>
                  <FormControlLabel control={<Checkbox defaultChecked />} label={prop.label} />
              </FormGroup>
            </Grid>)

            case 'radio':
              return (<Grid key={key} item xs={prop.grid || 12}>

        <FormControl>
              <FormLabel>Colors</FormLabel>
              <RadioGroup defaultValue="medium" name="radio-buttons-group">
                <Radio value="primary" label="Primary" color="primary" />
                <Radio value="neutral" label="Neutral" color="neutral" />
                <Radio value="danger" label="Danger" color="danger" />
                <Radio value="success" label="Success" color="success" />
                <Radio value="warning" label="Warning" color="warning" />
              </RadioGroup>
            </FormControl>

              <FormGroup>
                  <FormControlLabel control={<Checkbox defaultChecked />} label={prop.label} />
              </FormGroup>
            </Grid>)

            default:
              return (<Grid key={key} item xs={12} sm={prop.grid || 12} md={4} lg={3}>
                <TextField
                helperText={prop.helperText}
                // defaultValue={prop.default || ''}
                error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
             fullWidth id={key} type={prop.type} label={prop.label} variant="outlined" defaultValue={(profile && profile[key]) || ''}

              InputProps={ prop.suffix ? {
                endAdornment: <InputAdornment position="end">{prop.suffix}</InputAdornment>,
              } : {}}
              onChange={event => {
                handleProfileEditing(event, key)

                setInputsError(e => ({...e, [key]: prop.required && event.target.value === ""}))
              }}
                />
              </Grid>)

          }
        })}

  </Grid>)
  }, [inputsError, profile, setProfile])


    if (saving) return <Box sx={{ mt: 6}}><CircularProgress /></Box>
    return (<><Card sx={{ maxWidth: {xs: '100%', sm: '75%'}, md: '50%' }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="80%"
          image={profile.pictureUrl}
          alt={profile.displayName}
        />
        <CardContent>
        <Typography gutterBottom variant="h5" component="div">
        {profile.displayName}
        {/* {JSON.stringify(savedProfile.current)} */}
          </Typography>
        <Box sx={{ flexGrow: 1 }}>

          {/* MARK:- PROFILE EDITING */}

          {textfieldsGrid}
        {/* <Grid container spacing={1}>
          {Object.entries(personprops)
        .filter(([p, _ ]) => personprops[p].required)
        .map(([key, prop]) => {
          switch (prop.type) {
            case 'select':
              return (<Grid key={key} item xs={12}>
              <FormControl sx={{ minWidth: 120 }} >
                <InputLabel id={`${key}-select-label`}>{prop.label}</InputLabel>
                <Select
                  labelId={`${key}-select-label`}
                  id={`${key}-select`}
                  value={(profile && profile[key]) || ''}
                  label={prop.label}
                  onChange={event => {
                    if (editingTimer.current) clearTimeout(editingTimer.current)
                    editingTimer.current = setTimeout(() => {
                      handleProfileEditing(event, key)
                    }, 100);

                    }
                  }
                >
                  {prop.options.map(r => (<MenuItem key={r.order || r} value={r.name || r}>{r.name || r}</MenuItem>))}
                </Select>
              </FormControl>
              </Grid>)

            case 'multiple':
              return (<Grid key={key} item xs={12}>

                <TextField id={key} label={prop.label} variant="outlined"
            // onChange={event => handleProfileEditing(event, key)}
            onKeyDown={(ev) => {
              if (ev.key === 'Enter') {
                ev.preventDefault();
                setProfile(p => ({...p, [key]: p[key] ? [p[key], ev.target.value].join(prop.separator) : p[key]}))
                ev.target.value = ""
              }
            }}
              />

            {profile && profile[key] && profile[key] !== "null" && profile[key] !== "\"null\"" && prop.separator && (profile[key].split(prop.separator).length) ? <Paper
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                listStyle: 'none',
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
               {(profile[key].split(prop.separator).length).map((data) =>  // Array.isArray(profile[key])  ? profile[key] : [profile[key]]
                 (
                  <ListItem key={data}>
                    <Chip
                      label={data }
                      onDelete={() => {
                        setProfile(p => ({...p,
                            [key] :  (() => {
                              // (Array.isArray(p[key]) ?  p[key] : [p[key]]).filter(i => i !== data)
                              if (!p[key]) return ''
                              const splittedArray = p[key].split(prop.separator)
                              if (splittedArray && splittedArray.length) {
                                return splittedArray.filter(i => i !== data).join(prop.separator)
                              }
                              return p[key]

                            })()
                          }))
                      }}
                    />
                  </ListItem>
                )
              )}
            </Paper> : <></>}
            </Grid>)

            default:
              return (<Grid key={key} item xs={12}>
                <TextField id={key} type={prop.type} label={prop.label} variant="outlined" value={(profile && profile[key]) || ''}
              onChange={event => handleProfileEditing(event, key)}
                />
              </Grid>)

          }
        })}

        </Grid> */}


        {/* {JSON.stringify(inputsError)} */}
        </Box>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="large" color="primary" variant='contained' onClick={handleSubmit} disabled={noChanges} >
          บันทึก
        </Button>
        <Button size="small" color="error" onClick={() => {
          // setProfile(savedProfile.current)
          setSaving(true)
          setEditing(false)
        }}>
          ยกเลิก
        </Button>
      </CardActions>
    </Card>
    {tocsDialog}
    </>)
}